// extracted by mini-css-extract-plugin
export default {"lastSave":"iCboI","form":"R9497","header":"FgIlP","name":"tmA90","actions":"wky2I","action":"NvbJZ"};